import { useFormikContext } from "formik";
import { Paper, Stack } from "@mui/material";
import Schedule from "@/components/Schedule";
import { Branch } from "@/types/branch";

const ScheduleView = () => {
    const { values, setFieldValue } = useFormikContext<Branch>();

    return (
        <Stack spacing={2} flex={1} p={2}>
            <Paper sx={{ padding: 2 }}>
                <Schedule
                    title="Horarios de atención"
                    subtitle="Agrega los horarios en los que la sucursal estará abierta"
                    schedule={values.schedule}
                    onChange={(newSchedule) => setFieldValue("schedule", newSchedule)}
                />
            </Paper>
        </Stack>
    )
}

export default ScheduleView;
